import { FunctionComponent } from "react"
import { Button, Card } from "react-bootstrap"
import { useNavigate } from "react-router-dom"

interface IOpenDoorCard {}
const OpenDoorCard: FunctionComponent<IOpenDoorCard> = () => {
	const navigate = useNavigate()
	return (
		<Card className="mt-4">
			<Card.Header>Unlock Door</Card.Header>
			<Card.Body>
				<Card.Text>
					<ul>
						<li>Unlock a door remotely</li>
					</ul>
					<Button className="mt-4" onClick={() => navigate("/open-door")}>
						Unlock Door
					</Button>
				</Card.Text>
			</Card.Body>
		</Card>
	)
}
export default OpenDoorCard
